import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CaseManagementService } from '../../services/case-management.service';
import { UtilsService } from '../../edge/utils.service';
import { CaseActivityLogActions } from '@states/case-activity-log/case-activity-log.actions';
import { concatLatestFrom } from '@ngrx/operators';
import { caseActivityLogFeature } from '@states/case-activity-log/case-activity-log.feature';
import { catchError, map, share, switchMap } from 'rxjs';
import { SharedActions } from '@states/shared/shared.action-types';

@Injectable()
export class CaseActivityLogEffect {
  private readonly store$ = inject<Store<AppState>>(Store);
  private readonly actions$ = inject(Actions);
  private readonly caseManagementService = inject(CaseManagementService);
  private readonly utilService = inject(UtilsService);

  public beforeGetActivityLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CaseActivityLogActions.beforeGetActivityLogs),
      map(({caseId}) => CaseActivityLogActions.getActivityLogs({caseId}))
    )
  )

  public getCaseActivityLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CaseActivityLogActions.getActivityLogs),
      concatLatestFrom(() => [
        this.store$.select(caseActivityLogFeature.selectLatestTs),
        this.store$.select(caseActivityLogFeature.selectIsLastPage),
      ]),
      switchMap(([{caseId}, latestTs, isLastPage]) => {
        if (!isLastPage) {
          return this.caseManagementService.getActivityLogs(caseId, latestTs)
            .pipe(
              map((logs) => CaseActivityLogActions.getActivityLogsSuccess({ logs })),
              catchError((error) => [
                CaseActivityLogActions.getActivityLogsFail(),
                SharedActions.showMessage({error: this.utilService.errMessage(error)})
              ])
            );
        }
        return [SharedActions.doNothing()];
      }),
      share(),
    )
  )
}
